
import EshopRequest from '@/graphql/mutations/EshopRequest'
import { sync } from 'vuex-pathify'

export default {
  vessel: {
    wrapper: {
      width: 'full',
      lg: {
        width: '8xl',
        padding: 'xl',
      }
    },
    form: {
      backgroundColor: 'grey-lightest',
      paddingY: 'md',
      paddingX: 'sm',
      fontWeight: 'semibold',
      lg: {
        paddingY: 'md',
        paddingX: 'xl'
      }
    }
  },
  computed: {
    register: sync('registerForm'),
    mutation() {
      return EshopRequest
    },
    style() {
      return {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'top center',
        backgroundImage: 'url(/eshop/register-bg.svg)'
      }
    },
    items() {
      return [
        {
          $type: 'input',
          $id: 'name',
          $prop: 'name',
          label: this.$t('register.name'),
          $attrs: {
            span: { all: 2, md: 1 }
          },
          rules: [{
            required: true,
            message: this.$t('messages.required'),
            trigger: 'blur'
          }]
        },
        {
          $type: 'input',
          $id: 'email',
          $prop: 'email',
          label: this.$t('register.email'),
          $el: {
            type: 'email',
            placeholder: 'you@example.com'
          },
          $attrs: {
            span: { all: 2, md: 1 }
          },
          rules: [{
            required: true,
            message: this.$t('messages.required'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('messages.emailInvalid'),
            trigger: 'blur'
          }]
        },
        {
          $type: 'input',
          $id: 'phone',
          $prop: 'phone',
          label: this.$t('register.phone'),
          $el: {
            type: 'tel'
          },
          $attrs: {
            span: { all: 2, md: 1 }
          },
          rules: [{
            required: true,
            message: this.$t('messages.required'),
            trigger: 'blur'
          }]
        },
        {
          $type: 'input',
          $id: 'website',
          $prop: 'website',
          label: this.$t('register.website'),
          $attrs: {
            span: { all: 2, md: 1 }
          }
        },
        {
          $type: 'select',
          $id: 'solution',
          $prop: 'solution',
          label: this.$t('register.interestedIn'),
          $attrs: {
            span: { all: 2, md: 1 }
          },
          $options: [
            {
              label: this.$t('register.newEshop'),
              value: 'newEshop'
            },
            {
              label: this.$t('register.newWebsite'),
              value: 'newWebsite'
            },
            {
              label: this.$t('register.transferWebsite'),
              value: 'transferWebsite'
            },
            {
              label: this.$t('register.other'),
              value: 'other'
            }
          ],
          rules: [{
            required: true,
            message: this.$t('messages.required'),
            trigger: 'change'
          }]
        },
        {
          $type: 'select',
          $id: 'plan',
          $prop: 'plan',
          label: this.$t('register.plan'),
          $attrs: {
            span: { all: 2, md: 1 }
          },
          $options: [
            {
              label: 'Starter',
              value: 'Starter'
            },
            {
              label: 'Business',
              value: 'Business'
            },
            {
              label: 'Custom',
              value: 'Custom'
            },
          ],
          rules: [{
            required: true,
            message: this.$t('messages.required'),
            trigger: 'change'
          }]
        },
        {
          $type: 'input',
          $id: 'message',
          $prop: 'message',
          label: this.$t('register.message'),
          $el: {
            type: 'textarea',
            autosize: { minRows: 3, maxRows: 4 }
          },
          $attrs: {
            span: 2
          }
        }
      ]
    }
  }
}
